export default {
  store: 'Store',
  community: 'Community',
  documents: 'Documents',
  developer: 'Developer',
  admin: 'Manager',
  message: 'Message',
  language: 'Language',
  work: 'WorkOrder',
  lang: {
    english: 'English',
    chinese: 'Chinese',
    japanese: 'Japanese'
  },
  login: 'Login',
  // 费用信息
  feeInfo: ['Expense overview', 'Income and expenditure details', 'My Order', 'Invoice management', 'Ability price'],
  // 账户信息
  userInfo: {
    acountInfo: 'Acount info',
    robot: 'License info',
    operationLog: 'Operation log',
    key: 'My key',
    order: 'Order',
    downloadApp: 'My Apps',
    invoice: 'Invoice',
    cardP: 'My card package',
    logOut: 'Log Out'
  },
  'component.globalHeader.search': 'Search',
  'component.globalHeader.search.example1': 'Search example 1',
  'component.globalHeader.search.example2': 'Search example 2',
  'component.globalHeader.search.example3': 'Search example 3',
  'component.globalHeader.help': 'Help',
  'component.globalHeader.notification': 'Notification',
  'component.globalHeader.notification.empty': 'You have viewed all notifications.',
  'component.globalHeader.message': 'Message',
  'component.globalHeader.message.empty': 'You have viewed all messsages.',
  'component.globalHeader.event': 'Event',
  'component.globalHeader.event.empty': 'You have viewed all events.',
  'component.noticeIcon.clear': 'Clear',
  'component.noticeIcon.cleared': 'Cleared',
  'component.noticeIcon.empty': 'No notifications',
  'component.noticeIcon.view-more': 'View more'
}
